import React from 'react';
import { Layout } from 'react-admin';
import CustomMenu from './Menu';
import HeaderBarLayout from './header/HeaderBarLayout';

const CustomLayout = (props) => <Layout
    {...props}
    appBar={HeaderBarLayout}
    menu={CustomMenu}
/>;

export default CustomLayout;
